import { FORM_ITEM_TYPE } from "../../../configuration/components/index";
import _, { mixin } from 'lodash'
import { mock_config } from './config'
import Vue from 'vue'
export const mockFormData = [
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '账户&产品',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkRemoteSelect,  //
        payload: {
            label: "账户",    // 表单项的标题
            value: "",         // 表单项的值  1009742  账户 1557137109310036736 产品失败  账户1381945476990907008 产品成功   1336840310470225536
            field: "account_id",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择账户", trigger: "change" }], // 表单项的验证规则
            props: {
                initial: 'run',  // 表单项的初始值 是run 初始化自动运行 否则不运行 只涉及远程搜索
                isBatch: false,
                isSearch: false,
                fetch_type: 'get',  // 接口类型，可选 'get' | 'post'，默认为 'get'
                fetch_url: '/batch/account/list?plat_id=11',  // 接口函数
                params: [],  // 接口参数  待定
                placeholder: "请选择要创建广告的目标账户", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
            fetchDependencies: [],  // 远程的关联字段  远程搜索
            dependencies: [],  // 依赖项 
            effects: []
        },
    },
    {
        type: FORM_ITEM_TYPE.WkRemoteSelect,  //
        payload: {
            label: "产品",    // 表单项的标题
            value: [],         // 表单项的值
            field: "app_id",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择产品", trigger: "change" }], // 表单项的验证规则
            props: {
                isBatch: true,
                isSearch: false,
                fetch_type: 'get',  // 接口类型，可选 'get' | 'post'，默认为 'get'
                fetch_url: '/batch/app/list?plat_id=11&product_type=ANDROID_APP',  // 接口函数
                params: ['account_id'],  // 接口参数  待定
                placeholder: "请选择要投放的产品，可多选", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                multiple: true, // 表单项的多选
                style: "width: 600px", // 表单项的样式
                defaultData: [],
            }
        },
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '计划',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,
        payload: {
            label: "推广目标",
            value: "ANDROID_APP",
            field: "product_type",
            rules: [{ required: true, message: "请选择推广目标", trigger: "change" }],
            props: {
                defaultData: [],
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,
        payload: {
            label: "推广方式",
            value: "",
            field: "promotion_purpose",
            rules: [{ required: true, message: "请选择推广方式", trigger: "change" }],
            props: {
                defaultData: [],
            },
            visible: false,
            dependencies: ['product_type'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.product_type'
                    },
                    action: {
                        type: 'updateConfigOptions',
                        value: {
                            pathFields: ['product_type'],  // 用于构建路径的字段
                            field: 'promotion_purpose',      // 当前字段
                            hideWhenEmpty: true,  // 无选项时隐藏
                            clearWhenEmpty: true  // 无选项时清空值
                        }
                    }
                }
            ]
        }
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "流量场景",    // 表单项的标题
            value: "",         // 表单项的值
            field: "traffic_type",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择流量场景", trigger: "change" }], // 表单项的验证规则
            props: {
                defaultData: [],
            },
            visible: false,
            dependencies: ['promotion_purpose'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.promotion_purpose'
                    },
                    action: {
                        type: 'updateConfigOptions',
                        value: {
                            pathFields: ['promotion_purpose'],  // 用于构建路径的字段
                            field: 'traffic_type',      // 当前字段
                            hideWhenEmpty: true,  // 无选项时隐藏
                            clearWhenEmpty: true  // 无选项时清空值
                        }
                    }
                }
            ]
        },
    },
    {
        type: FORM_ITEM_TYPE.WkCheckBoxGroup,
        payload: {
            label: "预算",
            field: "day_budget_type",
            value: [],
            rules: [{ required: true, message: "请选择预算", trigger: "change" }],
            props: {
                checkBoxType: 'checkbox',
                defaultData: [
                    {
                        "label": "当日生效日预算",
                        "value": "1"
                    },
                    {
                        "label": "次日生效日预算",
                        "value": "2"
                    },
                    {
                        "label": "不限",
                        "value": "3"
                    }
                ]
            },
            dependencies: ['day_budget_type'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.day_budget_type.length != 0'
                    },
                    action: {
                        type: 'function',
                        value: (target) => {
                            let currentValue = target.formState.payload.value
                            if (currentValue.length >= 2) {
                                let lastValue = _.last(currentValue)
                                if (lastValue == '3') {
                                    target.formState.payload.value = ['3']
                                } else {
                                    target.formState.payload.value = _.without(currentValue, '3')
                                }
                            }
                        }
                    }
                }
            ]
        }
    },
    {
        type: 'ElInput',
        payload: {
            label: "当日生效日预算",
            field: "ad_day_budget",   // 表单项的唯一标识 提交 
            value: '',
            rules: [
                { required: true, message: "请输入当日生效日预算", trigger: "blur" },
                { pattern: /^(?:[1-9][0-9]{3,8})$/, message: "日预算范围为1000-999999999元", trigger: "blur" }
            ], // 表单项的验证规则
            props: {
                placeholder: "请输入当日生效日预算", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
                visible: false,
            },
            dependencies: ['day_budget_type'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.day_budget_type.includes("1")'
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: '!values.day_budget_type.includes("1")'
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                },
            ]
        }
    },
    {
        type: 'ElInput',
        payload: {
            label: "次日生效日预算",
            field: "ad_next_day_budget",   // 表单项的唯一标识 提交 
            value: '',
            rules: [
                { required: true, message: "请输入次日生效日预算", trigger: "blur" },
                { pattern: /^(?:[1-9][0-9]{3,8})$/, message: "日预算范围为1000-999999999元", trigger: "blur" }
            ],
            props: {
                placeholder: "请输入次日生效日预算", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
                visible: false,
            },
            dependencies: ['day_budget_type'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.day_budget_type.includes("2")'
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: '!values.day_budget_type.includes("2")'
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                }
            ]
        }
    },
    
    {
        type: FORM_ITEM_TYPE.WordsInput,  //'
        payload: {
            label: "计划名称",    // 表单项的标题
            value: "{项目名称}-{推广方式}-{版位}-{素材规格}-{定向包名称}-{付费方式}-{转化目标}-{深度转化目标}-{素材类型}-{创建日期}-{任务号-顺序号}-wk",         // 表单项的值
            field: "plan_name",   // 表单项的唯一标识 提交 
            rules: [
                { required: true, message: "请输入计划名称", trigger: "change" },
                { max: 100, message: "计划名称长度不能超过100个字符", trigger: "change" }
            ],
            props: {
                placeholder: "您可输入或选择通配符动态生成名称，但最终结果名称不可超过100字", // 表单项的提示
                inputStyle: "width: 600px", // 表单项的样式
                defaultData: [
                    {
                        "label": "项目名称",
                        "value": "项目名称"
                    },
                    {
                        "label": "推广方式",
                        "value": "推广方式"
                    },
                    {
                        "label": "版位",
                        "value": "版位"
                    },
                    {
                        "label": "素材规格",
                        "value": "素材规格"
                    },
                    {
                        "label": "定向包名称",
                        "value": "定向包名称"
                    },
                    {
                        "label": "付费方式",
                        "value": "付费方式"
                    },
                    {
                        "label": "转化目标",
                        "value": "转化目标"
                    },
                    {
                        "label": "深度转化目标",
                        "value": "深度转化目标"
                    },
                    {
                        "label": "素材类型",
                        "value": "素材类型"
                    },
                    {
                        "label": "创建日期",
                        "value": "创建日期"
                    },
                    {
                        "label": "任务号-顺序号",
                        "value": "任务号-顺序号"
                    },
                    {
                        "label": "wk",
                        "value": "wk"
                    }
                ]
            },
            onChange: ({ target, newValue }) => {  // 表单项的值改变后的回调函数
                return new Promise((resolve, reject) => {
                    if (newValue && !newValue.includes('任务号-顺序号')) {
                        target.$alert('任务号-顺序号、缺失可能会导致任务创建失败，请检查。', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning',
                            callback: action => {
                                resolve()
                            }
                        });
                    }
                })
            }
        }
    },
    {
        type: 'ElSwitch',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "计划状态",    // 表单项的标题
            value: "2",         // 表单项的值
            field: "plan_status",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择计划状态", trigger: "change" }], // 表单项的验证规则
            props: {
                activeValue: "1",  // 激活时的值
                inactiveValue: "2", // 非激活时的值
                defaultData: [
                    {
                        "label": "启动",
                        "value": "1"
                    },
                    {
                        "label": "暂停",
                        "value": "2"
                    },
                ]
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '任务',
            }
        }
    },
    {
        type: 'WkSelect',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "版位选择",    // 表单项的标题
            value: [],         // 表单项的值
            field: "ad_placement_id",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放版位", trigger: "change" }], // 表单项的验证规则
            props: {
                multiple: true, // 表单项的多选
                placeholder: "请选择投放版位", // 表单项的提示
                style: "width: 600px", // 表单项的样式
                defaultData: []
            }
        },
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,
        payload: {
            label: "是否预装",
            field: "install_pkg_type",
            value: "0",
            rules: [{ required: true, message: "请选择是否预装", trigger: "change" }],
            props: {
                radioType: 'radio',
                defaultData: [
                    {
                        "label": "非预装",
                        "value": "0"
                    },
                    {
                        "label": "预装",
                        "value": "1"
                    }
                ]
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.DynamicDate,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "投放日期",    // 表单项的标题
            value: [2, '', ''],         // 表单项的值
            field: "date",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放日期", trigger: "change" }], // 表单项的验证规则
            props: {},
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "投放时间",    // 表单项的标题
            value: "TIME_PERIOD_ALL",         // 表单项的值
            field: "time_period_type",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放日期", trigger: "change" }], // 表单项的验证规则
            props: {
                defaultData: [
                    {
                        "label": "全天",
                        "value": "TIME_PERIOD_ALL"
                    },
                    {
                        "label": "多个时间段",
                        "value": "TIME_PERIOD_HOUR_SPECIFIC"
                    }
                ]
            },
            dependencies: [],  // 依赖项 
        },
    },
    {
        type: FORM_ITEM_TYPE.WkDropTime,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "多个时间段",    // 表单项的标题
            value: '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',         // 表单项的值
            field: "times_drop",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放日期", trigger: "change" }], // 表单项的验证规则
            props: {
                visible: false,
            },
            dependencies: ["time_period_type"],  // 依赖项 
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: "values.time_period_type == 'TIME_PERIOD_HOUR_SPECIFIC'"
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: "values.time_period_type != 'TIME_PERIOD_HOUR_SPECIFIC'"
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                },

            ],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkCheckBoxGroup,
        payload: {
            label: "预算",
            field: "group_day_budget_type",
            value: [],
            rules: [{ required: true, message: "请选择预算", trigger: "change" }],
            props: {
                checkBoxType: 'checkbox',
                defaultData: [
                    {
                        "label": "当日生效日预算",
                        "value": "1"
                    },
                    {
                        "label": "次日生效日预算",
                        "value": "2"
                    },
                    {
                        "label": "不限",
                        "value": "3"
                    }
                ]
            },
            dependencies: ['group_day_budget_type'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.group_day_budget_type.length != 0'
                    },
                    action: {
                        type: 'function',
                        value: (target) => {
                            let currentValue = target.formState.payload.value
                            if (currentValue.length >= 2) {
                                let lastValue = _.last(currentValue)
                                if (lastValue == '3') {
                                    target.formState.payload.value = ['3']
                                } else {
                                    target.formState.payload.value = _.without(currentValue, '3')
                                }
                            }
                        }
                    }
                }
            ]
        }
    },
    {
        type: 'ElInput',
        payload: {
            label: "当日生效日预算",
            field: "group_ad_day_budget",   // 表单项的唯一标识 提交 
            value: '',
            rules: [
                { required: true, message: "请输入当日生效日预算", trigger: "blur" },
                { pattern: /^(?:[1-9][0-9]{3,8})$/, message: "日预算范围为1000-999999999元", trigger: "blur" }
            ], // 表单项的验证规则
            props: {
                placeholder: "请输入当日生效日预算", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
                visible: false,
            },
            dependencies: ['group_day_budget_type'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.group_day_budget_type.includes("1")'
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: '!values.group_day_budget_type.includes("1")'
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                }
            ]
        }
    },
    {
        type: 'ElInput',
        payload: {
            label: "次日生效日预算",
            field: "group_ad_next_day_budget",   // 表单项的唯一标识 提交 
            value: '',
            rules: [
                { required: true, message: "请输入次日生效日预算", trigger: "blur" },
                { pattern: /^(?:[1-9][0-9]{3,8})$/, message: "日预算范围为1000-999999999元", trigger: "blur" }
            ],
            props: {
                placeholder: "请输入次日生效日预算", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
                visible: false,
            },
            dependencies: ['group_day_budget_type'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.group_day_budget_type.includes("2")'
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: '!values.group_day_budget_type.includes("2")'
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                }
            ]
        }
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,
        payload: {
            label: "播放方式",
            field: "play_rate_type",
            value: "0",
            rules: [{ required: true, message: "请选择播放方式", trigger: "change" }],
            labelTip: '广告平台将根据选择的播放方式，在消耗不超出填写预算的情况下拿量：\n1.匀速播放：系统会主动基于广告分组填写预算，均匀分配至全投放时间段。预期广告消耗速率稳定。\n2.加速播放：系统将在不超出广告分组填写预算上不做广告消耗速率控制，优先保障拿量。预期投放初期广告消耗速率较快，并在投放中后期逐渐平稳。',
            props: {
                visible: false,
                radioType: 'radio',
                defaultData: [
                    {
                        "label": "匀速播放",
                        "value": "0"
                    },
                    {
                        "label": "加速播放",
                        "value": "1"
                    }
                ]
            },
            dependencies: ['group_day_budget_type'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: '!values.group_day_budget_type.includes("3")'
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.group_day_budget_type.includes("3")'
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                }
            ]
        }
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,
        payload: {
            label: "是否程序化",
            field: "programmatic",
            value: "0",
            rules: [{ required: true, message: "请选择是否程序化", trigger: "change" }],
            props: {
                radioType: 'radio',
                defaultData: [
                    {
                        "label": "非程序化",
                        "value": "0"
                    },
                    {
                        "label": "RTA",
                        "value": "1"
                    }
                ]
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkRemoteSelect,
        payload: {
            label: "RTA",
            field: "rta_id",
            value: "",
            rules: [{ required: true, message: "请选择RTA", trigger: "change" }],
            props: {
                placeholder: "请选择RTA",
                style: "width: 600px",
                initial: 'run',  // 表单项的初始值 是run 初始化自动运行 否则不运行 只涉及远程搜索
                isRemote: false,
                isBatch: false,
                isUpdate: true,
                fetch_type: 'get',  // 接口类型，可选 'get' | 'post'，默认为 'get'
                fetch_url: '/batch/rta/strategy/list?plat_id=11',  // 接口函数
                update_url: '/batch/rta/strategy/update',  // 更新接口
                update_type: 'post',  // 更新接口类型，可选 'get' | 'post'，默认为 'get'
                params: ['plat_id', 'account_id'],  // 接口参数  待定
                isSearch: false,   // 是否开启当前值作为查询接口参数
                plat_id: '11',
                placeholder: "请选择RTA", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
            dependencies: ['programmatic'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.programmatic == "1"'
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {    
                        type: 'expression',
                        expression: 'values.programmatic == "0"'
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                }
            ]
        }
    },
    {
        type: 'ElSwitch',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "是否跟随投放",    // 表单项的标题
            value: "0",         // 表单项的值
            field: "support_follow_delivery",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择是否跟随投放", trigger: "change" }], // 表单项的验证规则
            props: {
                activeValue: "1",  // 激活时的值
                inactiveValue: "0", // 非激活时的值
                defaultData: [
                    {
                        "label": "启动",
                        "value": "1"
                    },
                    {
                        "label": "暂停",
                        "value": "0"
                    },
                ]
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: 'ElInput',
        payload: {
            label: "跟投对象",
            field: "follow_delivery_object",   // 表单项的唯一标识 提交 
            value: '',
            rules: [], // 表单项的验证规则
            props: {
                placeholder: "请输入跟投对象", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
            dependencies: ['support_follow_delivery'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.support_follow_delivery == "1"'
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.support_follow_delivery == "0"'
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                }
            ]
        }
    },
    {
        type: 'ElInput',
        payload: {
            label: "跟投系数",
            field: "follow_delivery_ratio",   // 表单项的唯一标识 提交 
            value: '',
            rules: [
                { pattern: /^([1-9]|10|[1-9]\.\d{1,2})$/, message: "取值范围为1-10,最多两位小数", trigger: "blur" }
            ], // 表单项的验证规则
            props: {
                placeholder: "请输入跟投系数", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
            dependencies: ['support_follow_delivery'],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.support_follow_delivery == "1"'
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.support_follow_delivery == "0"'
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                }
            ]
        }
    },
    {
        type: 'ElSwitch',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "双出价保率",    // 表单项的标题
            value: "0",         // 表单项的值
            field: "protection_rate",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择双出价保率", trigger: "change" }], // 表单项的验证规则
            props: {
                activeValue: "1",  // 激活时的值
                inactiveValue: "0", // 非激活时的值
                defaultData: [
                    {
                        "label": "启动",
                        "value": "1"
                    },
                    {
                        "label": "暂停",
                        "value": "0"
                    },
                ]
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WordsInput,  //'
        payload: {
            label: "广告组名称",    // 表单项的标题
            value: "{项目名称}-{推广方式}-{版位}-{素材规格}-{定向包名称}-{付费方式}-{转化目标}-{深度转化目标}-{素材类型}-{创建日期}-{任务号-顺序号}-wk",         // 表单项的值
            field: "adgroup_name",   // 表单项的唯一标识 提交 
            rules: [
                { required: true, message: "请输入广告组名称", trigger: "change" },
                { max: 100, message: "广告组名称长度不能超过100个字符", trigger: "change" }
            ], // 表单项的验证规则
            props: {
                placeholder: "您可输入或选择通配符动态生成名称，但最终结果名称不可超过100字", // 表单项的提示
                inputStyle: "width: 600px", // 表单项的样式
                defaultData: [
                    {
                        "label": "项目名称",
                        "value": "项目名称"
                    },
                    {
                        "label": "推广方式",
                        "value": "推广方式"
                    },
                    {
                        "label": "版位",
                        "value": "版位"
                    },
                    {
                        "label": "素材规格",
                        "value": "素材规格"
                    },
                    {
                        "label": "定向包名称",
                        "value": "定向包名称"
                    },
                    {
                        "label": "付费方式",
                        "value": "付费方式"
                    },
                    {
                        "label": "转化目标",
                        "value": "转化目标"
                    },
                    {
                        "label": "深度转化目标",
                        "value": "深度转化目标"
                    },
                    {
                        "label": "素材类型",
                        "value": "素材类型"
                    },
                    {
                        "label": "创建日期",
                        "value": "创建日期"
                    },
                    {
                        "label": "任务号-顺序号",
                        "value": "任务号-顺序号"
                    },
                    {
                        "label": "wk",
                        "value": "wk"
                    }
                ]
            },
            // onChange: ({ target, newValue }) => {  // 表单项的值改变后的回调函数
            //     let ele_adgroup_name = document.querySelector('input[field="adgroup_name"]')
            //     if(ele_adgroup_name) {
            //         // 先移除已有的监听器
            //         ele_adgroup_name.removeEventListener('blur', ele_adgroup_name._blurHandler)

            //         // 创建新的监听器
            //         ele_adgroup_name._blurHandler = () => {
            //             if(!newValue) {
            //                 return
            //             }
            //             let plan_allocation_rules_label = target.rootFormDataOptions?.plan_allocation_rules.filter(item => target.rootFormData?.plan_allocation_rules.includes(item.value) && item.value != 'element_group').map(item => {
            //                 if(item.value == 'app') {
            //                     return '项目名称'
            //                 }else if(item.value == 'target') { 
            //                     return '定向包名称'
            //                 }else {
            //                     return item.label
            //                 }
            //             })
            //             let isEvery = plan_allocation_rules_label.every(item => newValue.includes(item))
            //             if (!isEvery) {
            //                 target.$alert('计划分配规则与计划名称通配符不匹配，可能会导致计划名称过长，请检查。', '提示', {
            //                     confirmButtonText: '确定',
            //                     type: 'warning'
            //                 });
            //             }
            //         }

            //         // 添加新的监听器
            //         ele_adgroup_name.addEventListener('blur', ele_adgroup_name._blurHandler)
            //     }
            // }
        }
    },
    {
        type: 'ElSwitch',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "广告组状态",    // 表单项的标题
            value: "2",         // 表单项的值
            field: "adgroup_status",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择广告组状态", trigger: "change" }], // 表单项的验证规则
            props: {
                activeValue: "1",  // 激活时的值
                inactiveValue: "2", // 非激活时的值
                defaultData: [
                    {
                        "label": "启动",
                        "value": "1"
                    },
                    {
                        "label": "暂停",
                        "value": "2"
                    },
                ]
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '创意',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WordsInput,  //'
        payload: {
            label: "创意名称",    // 表单项的标题
            value: "{项目名称}-{推广方式}-{版位}-{素材规格}-{定向包名称}-{付费方式}-{转化目标}-{深度转化目标}-{素材类型}-{创建日期}-{任务号-顺序号}-wk",         // 表单项的值
            field: "creative_name",   // 表单项的唯一标识 提交 
            rules: [
                { required: true, message: "请输入创意名称", trigger: "change" },
                { max: 100, message: "创意名称长度不能超过100个字符", trigger: "change" }
            ], // 表单项的验证规则
            props: {
                placeholder: "您可输入或选择通配符动态生成名称，但最终结果名称不可超过100字", // 表单项的提示
                inputStyle: "width: 600px", // 表单项的样式
                defaultData: [
                    {
                        "label": "项目名称",
                        "value": "项目名称"
                    },
                    {
                        "label": "推广方式",
                        "value": "推广方式"
                    },
                    {
                        "label": "版位",
                        "value": "版位"
                    },
                    {
                        "label": "素材规格",
                        "value": "素材规格"
                    },
                    {
                        "label": "定向包名称",
                        "value": "定向包名称"
                    },
                    {
                        "label": "付费方式",
                        "value": "付费方式"
                    },
                    {
                        "label": "转化目标",
                        "value": "转化目标"
                    },
                    {
                        "label": "深度转化目标",
                        "value": "深度转化目标"
                    },
                    {
                        "label": "素材类型",
                        "value": "素材类型"
                    },
                    {
                        "label": "创建日期",
                        "value": "创建日期"
                    },
                    {
                        "label": "任务号-顺序号",
                        "value": "任务号-顺序号"
                    },
                    {
                        "label": "wk",
                        "value": "wk"
                    }
                ]
            },
        }
    },
    {
        type: 'ElSwitch',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "创意状态",    // 表单项的标题
            value: "2",         // 表单项的值
            field: "creative_status",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择广告组状态", trigger: "change" }], // 表单项的验证规则
            props: {
                activeValue: "1",  // 激活时的值
                inactiveValue: "2", // 非激活时的值
                defaultData: [
                    {
                        "label": "启动",
                        "value": "1"
                    },
                    {
                        "label": "暂停",
                        "value": "2"
                    },
                ]
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '分配规则',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkCheckBoxGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "计划分配规则",    // 表单项的标题
            value: ['app'],         // 表单项的值
            field: "plan_allocation_rules",   // 表单项的唯一标识 提交
            labelTip: '"按照选择的选项与实际配置的内容，每一种不同的组合将创建一个新的计划。当计划与任务分配规则选择一致时，表示一个计划下一个任务。如：选择了应用与定向，选择了2个应用，上传了2个定向包，则为2*2=4个计划。"',  // 表单项的提示
            rules: [{ required: true, message: "请选择计划分配规则", trigger: "change" }], // 表单项的验证规则
            props: {
                defaultData: [
                    {
                        "label": "产品",
                        "value": "app",
                    },
                    {
                        "label": "推广方式",
                        "value": "promotion_purpose",
                    },
                    {
                        "label": "版位",
                        "value": "display_type",
                    },
                    {
                        "label": "素材规格",
                        "value": "ad_creative_spec"
                    },
                    {
                        "label": "定向",
                        "value": "target",
                    },
                    {
                        "label": "付费方式",
                        "value": "pay_type"
                    },
                    {
                        "label": "转化目标",
                        "value": "conv_type"
                    },
                    {
                        "label": "深度转化目标",
                        "value": "ocpx_deep_type"
                    },
                    {
                        "label": "素材类型",
                        "value": "material_type"
                    },
                    {
                        "label": "创意组",
                        "value": "element_group"
                    }
                ]
            },
            onChange: ({ target, newValue, oldValue }) => {  // 表单项的值改变后的回调函数
                if (!target.rootFormData.adgroup_name || target.rootFormData.adgroup_name.length == 0) {
                    return
                }
                const getRuleLabel = (item) => {
                    const labelMap = {
                        'app': '项目名称',
                        'target': '定向包名称'
                    };
                    return labelMap[item.value] || item.label;
                };

                const rules = target.rootFormDataOptions?.plan_allocation_rules
                    .filter(item => item.value !== 'element_group');

                if (newValue.length < oldValue.length) {
                    const channel_item = _.without(oldValue, ...newValue);
                    // const plan_allocation_rules_list = rules.map(getRuleLabel);
                    const plan_allocation_rules_label = rules
                        .filter(item => channel_item.includes(item.value))
                        .map(getRuleLabel);
                    // const without = _.without(plan_allocation_rules_list, ...plan_allocation_rules_label);
                    const isEvery = plan_allocation_rules_label.some(item => target.rootFormData.adgroup_name.includes(item));
                    if (isEvery) {
                        return new Promise((resolve) => {
                            target.$alert('计划分配规则与计划名称通配符不匹配，可能会导致计划名称过长，请检查。', '提示', {
                                confirmButtonText: '确定',
                                type: 'warning',
                                callback: () => resolve()
                            });
                        });
                    }
                    return
                }



            },
            dependencies: ['adgroup_allocation_rules'],  // 依赖项 
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: '!values.adgroup_allocation_rules.includes("material_type") || !values.adgroup_allocation_rules.includes("element_group")'
                    },
                    action: {
                        type: 'function',
                        value: (target) => {
                            let value = []
                            let plan_allocation_rules_values = target.rootFormData.plan_allocation_rules
                            if (!target.rootFormData.adgroup_allocation_rules.includes('material_type')) {
                                value = _.without(plan_allocation_rules_values, 'material_type')
                                plan_allocation_rules_values = value
                            }
                            if (!target.rootFormData.adgroup_allocation_rules.includes('element_group')) {
                                value = _.without(plan_allocation_rules_values, 'element_group')
                            }
                            let uniq_value = _.uniq(value)
                            Vue.set(target.formState.payload, 'value', uniq_value);
                        }
                    }
                }
            ]
        },
    },
    {
        type: FORM_ITEM_TYPE.WkCheckBoxGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "任务分配规则",    // 表单项的标题
            value: ['app', 'promotion_purpose', 'display_type', 'ad_creative_spec', 'target', 'pay_type', 'conv_type', 'ocpx_deep_type'],         // 表单项的值
            field: "adgroup_allocation_rules",   // 表单项的唯一标识 提交
            labelTip: "按照选择的选项与实际配置的内容，每一种不同的组合将创建一个新的任务。当计划与任务分配规则选择一致时，表示一个计划下一个任务。如：选择了应用与定向，选择了2个应用，上传了2个定向包，则为2*2=4个任务。",
            rules: [{ required: true, message: "请选择应用用户", trigger: "change" }], // 表单项的验证规则
            props: {
                defaultData: [
                    {
                        "label": "产品",
                        "value": "app",
                        "disabled": true
                    },
                    {
                        "label": "推广方式",
                        "value": "promotion_purpose",
                        "disabled": true
                    },
                    {
                        "label": "版位",
                        "value": "display_type",
                        "disabled": true
                    },
                    {
                        "label": "素材规格",
                        "value": "ad_creative_spec",
                    },
                    {
                        "label": "定向",
                        "value": "target",
                        "disabled": true
                    },
                    {
                        "label": "付费方式",
                        "value": "pay_type",
                        "disabled": true
                    },
                    {
                        "label": "转化目标",
                        "value": "conv_type",
                        "disabled": true
                    },
                    {
                        "label": "深度转化目标",
                        "value": "ocpx_deep_type",
                        "disabled": true
                    },
                    {
                        "label": "素材类型",
                        "value": "material_type"
                    },
                    {
                        "label": "创意组",
                        "value": "element_group"
                    }
                ]
            },
            dependencies: ['plan_allocation_rules'],  // 依赖项 
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.plan_allocation_rules.includes("material_type") || values.plan_allocation_rules.includes("element_group")'
                    },
                    action: {
                        type: 'function',
                        value: (target) => {
                            let result = []
                            if (target.rootFormData.plan_allocation_rules.includes('material_type')) {
                                result.push('material_type')
                            }
                            if (target.rootFormData.plan_allocation_rules.includes('element_group')) {
                                result.push('element_group')
                            }
                            let value = _.uniq([...target.rootFormData.adgroup_allocation_rules, ...result])
                            Vue.set(target.formState.payload, 'value', value);
                        }
                    }
                }
            ]
        },
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '分产品配置',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkHonorProductConfig,
        payload: {
            field: 'product_config_list',
            label: "分产品配置侧边栏",
            labelTip: "为每个产品配置独有的选项内容，该产品的计划、任务、创意将使用分别维护的信息进行创建。",
            rules: [{ required: true, type: 'array', message: "分产品配置不可为空", trigger: "change" }],
            value: [],
            props: {
                defaultData: "分产品配置侧边栏",
                type: "primary",
                // fn: (params) => (productConfigDrawer({ props: { visible: true, ...params } }))
            },
        }
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '叉乘元素',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkBlockText,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                text: '叉乘条件:不同应用、版位的转化出价分别 × 不同应用、版位的创意组分别 × 不同应用定向包 = 广告创意数量',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkHonorModalForm,
        payload: {
            field: 'modalForm',
            value: [null, null, null, {}],
            props: {

            }
        }
    }
]

